import { useOutletContext } from 'react-router-dom'

/** Context every tenant-admin screen receives from TenantAdminShell. */
export interface TenantAdminContext {
  slug: string
  /** Branded display name (falls back to the GSA's registered name). */
  displayName: string
}

/** Typed accessor for the shell's outlet context. */
export function useTenantAdmin(): TenantAdminContext {
  return useOutletContext<TenantAdminContext>()
}
